import { render, staticRenderFns } from "./LinkMainDialog.vue?vue&type=template&id=61053602&scoped=true&"
import script from "./LinkMainDialog.vue?vue&type=script&lang=js&"
export * from "./LinkMainDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61053602",
  null
  
)

export default component.exports